import { colors } from '../../colors';
var pagination = {
  activeColor: colors.cerulean,
  defaultColor: colors.onyx
};
export default pagination;